import Relay from 'react-relay';

export interface RejectTestRunMutationProps {
    testInvocation: {
        id: string;
        realId?: string;
        version: number;
    };
    testRun: {
        id: string;
        realId?: string;
    };
}

export default class RejectTestRunMutation extends Relay.Mutation<RejectTestRunMutationProps, any> {
    private mutationProps: RejectTestRunMutationProps;

    constructor(props: RejectTestRunMutationProps) {
        super(props as any);
        this.mutationProps = props;
    }

    getMutation() {
        return Relay.QL`mutation {rejectTestRun}`;
    }

    getFatQuery() {
        return Relay.QL`
            fragment on RejectTestRunPayload {
                testInvocation {
                    id
                }
                rejectedTestRunId
                success
                error
            }
        `;
    }

    getConfigs() {
        return [
            {
                type: 'REQUIRED_CHILDREN',
                children: [this.getFatQuery()],
            }
        ];
    }

    getVariables() {
        return {
            testRunId: this.mutationProps.testRun.realId || this.mutationProps.testRun.id,
            testInvocationId: this.mutationProps.testInvocation.realId || this.mutationProps.testInvocation.id,
            version: this.mutationProps.testInvocation.version,
        };
    }

    getOptimisticResponse() {
        return {
            rejectedTestRunId: this.mutationProps.testRun.realId || this.mutationProps.testRun.id,
            success: true,
        };
    }
}
